<template>
    <b-col cols="12" class="p-3">
        <div v-show="!loading">
            <div v-html="svg_loaded" class="text-center"></div>

            <template v-if="!loading && load_popover">
                <b-popover v-for="zona in secciones" :key="zona.id" :target="'popover-' + zona.id" triggers="hover focus">
                    <template slot="title">{{ zona.name }}</template>
                    <span v-if="!zona.esta_disponible && zona.tiene_precios">{{ $t('partidos.agotadas') }}</span>
                    <span v-else-if="!zona.esta_disponible && !zona.tiene_precios">{{ $t('mapa.no_disponible') }}</span>
                </b-popover>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </template>
    </b-col>
</template>

<script>
    export default {
        props: {
            secciones: {
                type: Array,
                required: true
            }, 
            zona_id: {
                type: Number,
                required: false
            },
            svg: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                load_popover: true
            }            
        },
        created() {
            this.loadSVG(this.svg);

            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if(/windows phone/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/android/i.test(userAgent)) {
                this.load_popover = false;
            }

            if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                this.load_popover = false;
            }

        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        methods : {
            loadSVG(svg) {
                this.svg_loaded = svg;

                var vue_instance = this;

                setTimeout(() => {
                    var regions = document.getElementsByClassName("recinto-zona");

                    for(var i in regions) {
                        if(regions[i].dataset !== undefined) {
                            for(let j in this.secciones) {
                                if(this.secciones[j].id == regions[i].dataset.region) {
                                    if (!this.secciones[j].esta_disponible) {
                                        regions[i].classList.add('plaza_ocupada');
                                    } else {
                                        regions[i].addEventListener('click', function() {
                                            vue_instance.clickRegion(this.dataset.region);
                                        }, false);
                                    }
                                }
                            }
                        }                                                                                            
                    }
                    
                    this.loading = false;
                    this.$emit('cargado');
                }, 1000);                
            },
            clickRegion(region_id) {
                let zona = null;
                for(let i in this.secciones) {
                    if(this.secciones[i].id == region_id) {
                        zona = this.secciones[i];
                    }
                }

                if(zona) {
                    this.$emit('clickZona', zona);
                }            
            }        
        }
    }
</script>